export default function Reassurances() {
  const items = [
    { icon: "ri-time-line", label: "Intervention 24h" },
    { icon: "ri-file-list-3-line", label: "Devis gratuit" },
    { icon: "ri-shield-check-line", label: "Toutes marques" },
    { icon: "ri-award-line", label: "Garantie 10 ans" },
  ];

  return (
    <section className="bg-white border-b border-brand-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-0">
          {items.map((item) => (
            <div
              key={item.label}
              className="flex items-center justify-center gap-3 py-5 md:py-6 border-r border-brand-border last:border-r-0"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${item.icon} text-brand-cyan text-xl`}></i>
              </div>
              <span className="text-brand-blue text-sm font-semibold whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}